import React, { ReactElement, useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { PrivateRoute } from 'app/routes';

import { ContentNavbar } from 'features/navbar';
import { Flex } from 'components';
import Menu, { Menu2 } from 'features/menu';
import FullscreenProvider from 'features/fullscreen';
import { ContentTypeEnum, useContents } from 'features/contents';
import { useSheets } from 'features/dashboard-new';
import { useSchool } from 'features/school';
import Footer from 'features/footer';
import { useBreakpoints } from 'app/hooks';

const ContentLayout = (): ReactElement => {
  const { usingDashboard, getDashboardUi } = useSheets();
  const { contentDetails } = useContents();
  const { schoolAlias } = useSchool();
  const breakpoint = useBreakpoints();

  useEffect(() => {
    getDashboardUi();
  }, []);

  const [searchParams] = useSearchParams();
  const isMobileToken = searchParams.has('isMobileToken');

  return (
    <PrivateRoute>
      <Flex className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`} flexWrap="inherit" minHeight="100vh" flexDirection="column">
        <FullscreenProvider display="flex" flexDirection="column">
          <Flex flexGrow={0}>
            {!isMobileToken ? (
              <>
                {usingDashboard ? <Menu2 /> : <Menu />}
                <ContentNavbar />
              </>
            ) : null}
          </Flex>

          <Flex as="main" flexWrap="nowrap" flexDirection="column">
            <Outlet />
          </Flex>
        </FullscreenProvider>

        {contentDetails?.contentType !== ContentTypeEnum.Video ||
          (!isMobileToken && (
            <Flex flexGrow={0}>
              <Footer />
            </Flex>
          ))}
      </Flex>
    </PrivateRoute>
  );
};

export default ContentLayout;
